import { USE_API, API_URL, API_PASSWORD } from '../config';

// API Service for managing blog posts
// Supports both localStorage (demo) and Cloudflare Workers API (production)

class PostsAPI {
  constructor() {
    this.useAPI = USE_API;
    this.apiURL = API_URL;
    this.apiPassword = API_PASSWORD;
  }

  // Fetch all posts
  async getPosts() {
    if (this.useAPI) {
      try {
        const response = await fetch(`${this.apiURL}/api/posts`);
        if (!response.ok) {
          throw new Error('Failed to fetch posts');
        }
        return await response.json();
      } catch (error) {
        console.error('API Error:', error);
        // Fallback to localStorage
        return this.getPostsFromLocalStorage();
      }
    } else {
      return this.getPostsFromLocalStorage();
    }
  }

  // Create a new post
  async createPost(post) {
    if (this.useAPI) {
      try {
        const response = await fetch(`${this.apiURL}/api/posts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.apiPassword}`,
          },
          body: JSON.stringify(post),
        });
        
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message || 'Failed to create post');
        }
        
        return await response.json();
      } catch (error) {
        console.error('API Error:', error);
        throw error;
      }
    } else {
      return this.createPostInLocalStorage(post);
    }
  }

  // Delete a post
  async deletePost(postId) {
    if (this.useAPI) {
      try {
        const response = await fetch(`${this.apiURL}/api/posts/${postId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${this.apiPassword}`,
          },
        });
        
        if (!response.ok) {
          throw new Error('Failed to delete post');
        }
        
        return await response.json();
      } catch (error) {
        console.error('API Error:', error);
        throw error;
      }
    } else {
      return this.deletePostFromLocalStorage(postId);
    }
  }

  // LocalStorage methods (fallback)
  getPostsFromLocalStorage() {
    const saved = localStorage.getItem('geomark_posts');
    return saved ? JSON.parse(saved) : [];
  }

  createPostInLocalStorage(post) {
    const posts = this.getPostsFromLocalStorage();
    posts.unshift(post);
    localStorage.setItem('geomark_posts', JSON.stringify(posts));
    return post;
  }

  deletePostFromLocalStorage(postId) {
    const posts = this.getPostsFromLocalStorage();
    const updated = posts.filter(p => p.id !== postId);
    localStorage.setItem('geomark_posts', JSON.stringify(updated));
    return { success: true };
  }
}

const postsAPI = new PostsAPI();
export default postsAPI;
